import React from "react";
import {
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Box,
} from "@mui/material";
import { Controller } from "react-hook-form";

const TravelPreferences = ({ control }) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Box display="flex" alignItems="center">
        <Controller
          name="tripType"
          control={control}
          render={({ field }) => (
            <RadioGroup row {...field}>
              <FormControlLabel
                value="return"
                control={<Radio />}
                label="Return"
              />
              <FormControlLabel
                value="oneWay"
                control={<Radio />}
                label="One Way"
              />
            </RadioGroup>
          )}
        />
      </Box>
      <Box display="flex" alignItems="center" marginRight={2}>
        <FormControlLabel
          control={
            <Controller
              name="directFlightsOnly"
              control={control}
              render={({ field }) => (
                <Checkbox {...field} checked={field.value} />
              )}
            />
          }
          label="Direct Flights Only"
        />
      </Box>
    </Box>
  );
};

export default TravelPreferences;
